import Image from "next/image";
import { FunctionComponent } from "react";

import styles from "./Score.module.scss";

import { selectColor } from "@lib/helper/scoreUtils";
import { trafficLightImages } from "@lib/images";

type ScoreSize = "big" | "small";

export interface IScoreProps {
  value?: number;
  size?: ScoreSize;
  className?: string;
}

const Score: FunctionComponent<IScoreProps> = ({ value, className, size = "small" }) => {
  if (!value) return <></>;

  const roundedValue = Math.round(value);
  const imageTrafficLight = trafficLightImages.colorless;
  const color = selectColor(roundedValue);

  const imageClassName = styles[`score__icon__image${color}`];
  const sizeClassName = styles[`size-${size}`];

  return (
    <div className={`${styles["score"]} ${sizeClassName} ${className}`}>
      <div className={styles["score__icon"]}>
        <div className={`${styles["score__icon__image"]} ${imageClassName}`}>
          <Image
            src={imageTrafficLight}
            alt="Traffic light"
            priority={true}
            fill
            sizes="100vw"
            style={{
              objectFit: "contain",
            }}
          />
        </div>
      </div>
      <div className={styles["score__text"]}>{roundedValue}/100</div>
    </div>
  );
};

export default Score;
